import type { BaseModelAttributes } from './base';
import { TaskStatus, TaskStatusLabels } from './taskStatus';
import { I18nLabels } from './common';

// ⭐ 统一使用 TaskStatus，保留类型别名以向后兼容
export type VideoLipsyncStatus = TaskStatus;
export const VideoLipsyncStatus = TaskStatus;

// ⭐ 使用统一的状态标签
export const VideoLipsyncStatusLabels: I18nLabels<VideoLipsyncStatus> = TaskStatusLabels;

export interface IVideoLipsync extends BaseModelAttributes {
  videoUrl: string;
  audioUrl: string;
  modelId: string;
  status: VideoLipsyncStatus;
  taskId?: string;
  resultMessage?: string;
  resultVideoUrl?: string;
  submittedAt: Date;
  userId: string;
  user?: {
    id: string;
    name: string;
    email: string;
  };
}

export interface CreateVideoLipsyncRequest {
  videoUrl: string;
  audioUrl: string;
  modelId: string;
}

export interface UpdateVideoLipsyncRequest {
  videoUrl?: string;
  audioUrl?: string;
  modelId?: string;
  status?: VideoLipsyncStatus;
  taskId?: string;
  resultMessage?: string;
  resultVideoUrl?: string;
}

export interface VideoLipsyncQuery {
  search?: string;
  userId?: string;
  status?: VideoLipsyncStatus;
  modelId?: string;
}